"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var controls_1 = require("./controls");
var controlRoutes = [
    {
        component: controls_1.ChangeViewComponent,
        path: 'diff-view/:category/:instanceId/:userId/:firstVersionId/:secondVersionId',
    },
    {
        component: controls_1.ChangeViewComponent,
        path: 'diff-view/:category/:instanceId/:userId/:createVersion',
    },
];
exports.dynamicControlsRouting = router_1.RouterModule.forChild(controlRoutes);
//# sourceMappingURL=dynnamic-controls.routes.js.map